module.exports = "pegasus/assets/blocks/column-lp6-themelp1.png";